export var defaultLanguage = {
    id: "en",
    title: "English",
    icon: "\uD83C\uDDFA\uD83C\uDDF8"
};
export var Languages = [
    defaultLanguage,
    {
        id: "fr",
        title: "French",
        icon: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        id: "nl",
        title: "Dutch",
        icon: "\uD83C\uDDE7\uD83C\uDDEA"
    }
];

//# sourceMappingURL=Languages.js.map